import { createSlice } from '../../utils/createAppSlice'
import { initialState } from './agentsInitialState'
import {
	loadCommonAgents,
	rejected,
	pending,
	fulfilledLoadCustomAgents,
	fulfilledLoadProviderAgents,
} from './agentsReducers'
import { getCommonAgents, getCustomAgents, getProviderAgents } from './agentsSelectors'
import { fetchCustomAgents, fetchProviderAgents } from './agentsAsyncMethods'

export const agentsSlice = createSlice({
	name: 'agents',
	initialState,
	reducers: (create) => ({
		actionLoadCommonAgents: create.reducer(loadCommonAgents),
		actionLoadProviderAgents: create.asyncThunk(fetchProviderAgents, {
			pending: (state) => pending(state, 'providerAgents'),
			rejected: (state) => rejected(state, 'providerAgents'),
			fulfilled: fulfilledLoadProviderAgents,
		}),
		actionLoadCustomAgents: create.asyncThunk(fetchCustomAgents, {
			pending: (state) => pending(state, 'customAgents'),
			rejected: (state) => rejected(state, 'customAgents'),
			fulfilled: fulfilledLoadCustomAgents,
		}),
	}),
	selectors: {
		selectCommonAgents: getCommonAgents,
		selectCustomAgents: getCustomAgents,
		selectProviderAgents: getProviderAgents,
	},
})

export const { actionLoadCustomAgents, actionLoadCommonAgents, actionLoadProviderAgents } = agentsSlice.actions

export const { selectCommonAgents, selectCustomAgents, selectProviderAgents } = agentsSlice.selectors
